import './style.scss';
import $ from 'jquery';
import gsap from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger.js";

gsap.registerPlugin(ScrollTrigger);

function revealFunction() {
    if($('.wp-block-keztablocks-progress-bars').length > 0) {
    	$('.wp-block-keztablocks-progress-bars').each(function() {
    		var self = $(this),
                bar = self.find('.wp-block-keztablocks-progress-bar');
                bar.each(function() {
        			var progressBar = $(this).find('.wp-block-keztablocks-progress-bar__inner'),
        			    count = $(this).find('.wp-block-keztablocks-progress-bar__count'),
        			    tl = gsap.timeline({
                            scrollTrigger: {
                                trigger: self,
                                start: "+=100 bottom"
                            }
                        });

                    tl
                        .fromTo(progressBar, {autoAlpha:0}, {duration:0.3, autoAlpha:1})
                        .fromTo(progressBar, {width: 0}, {duration:1,width: progressBar.data("width") + '%', onUpdate:countPercent}, "<");
                    
                    function countPercent() {
            			var newPercent = (tl.progress()*progressBar.data("width")).toFixed();
            			count.text(newPercent + "%");
            		}
                });
    	});
    }
}
$(window).on('load', () => {
  if($('.c-loader').length) {
    setTimeout(() => { 
          revealFunction();
      }, 3200);
  } else {
    setTimeout(() => { 
          revealFunction();
      }, 400);
  }
})